export default __webpack_public_path__ + "static/why-i-run-vertical-9b210065ff60f954cccbb7446aa4d7d6.png";